// extracted by mini-css-extract-plugin
export default {"indexesItem":"IndexCard_indexesItem__s1qPt"};